import { AttributeCondition, NotExistsComparator, StringEqualsComparator, NumericBetweenComparator, NumericGreaterThanComparator, NumericLessThanComparator, GeoPointCloserThanComparator, GeoPointFartherThanComparator } from '@leverege/ui-attributes';
import { LogicCondition } from '@leverege/condition';
import ConditionFilterModel from "../../../../filters/filter/ConditionFilterModel.js";
import { FilterSourceModel } from "../../../../filters/index.js";
export function createTermsConditionFilter(data, {
  queryModel,
  objectType,
  delegate,
  context
}) {
  const value = data?.key;
  const {
    attrName,
    missing
  } = queryModel;
  if (!attrName) {
    return null;
  }
  const isEmpty = missing === value;
  let filterSource = FilterSourceModel.create();
  let attributeCondition = AttributeCondition.create({
    attrName
  });
  let comparator;
  if (isEmpty) {
    comparator = NotExistsComparator.create();
  } else {
    comparator = StringEqualsComparator.create();
    comparator = StringEqualsComparator.setValue1(comparator, [value]);
  }
  attributeCondition = AttributeCondition.setComparator(attributeCondition, comparator);
  let rootCondition = ConditionFilterModel.create({
    objectType
  });
  rootCondition = ConditionFilterModel.setRootCondition(rootCondition, LogicCondition.create({
    conditions: [attributeCondition],
    operator: 'and'
  }));
  const filter = delegate.convertToFilter(rootCondition, context);
  filterSource = FilterSourceModel.setFilter(filterSource, filter);
  filterSource = FilterSourceModel.setMetadata(filterSource, {
    filter: rootCondition
  });
  return filterSource;
}
createTermsConditionFilter.TYPE = 'aggregation.terms';
export function createGeoDistanceRangeFilter(data, {
  queryModel,
  objectType,
  delegate,
  context
}) {
  const value = data?.key;
  const {
    attrName
  } = queryModel;
  if (!attrName) {
    return null;
  }
  if (!value) {
    return null;
  }
  const {
    from,
    to
  } = data;
  let filterSource = FilterSourceModel.create();
  const conditions = [];
  let lowerBoundCondition;
  let upperBoundCondition = AttributeCondition.create({
    attrName
  });
  let upperBoundComparator = GeoPointCloserThanComparator.create();
  upperBoundComparator = GeoPointCloserThanComparator.setValue1(upperBoundComparator, queryModel.origin);
  upperBoundComparator = GeoPointCloserThanComparator.setUnits(upperBoundComparator, queryModel.unit);
  upperBoundComparator = GeoPointCloserThanComparator.setDistance(upperBoundComparator, to);
  upperBoundCondition = AttributeCondition.setComparator(upperBoundCondition, upperBoundComparator);
  conditions.push(upperBoundCondition);
  if (from > 0) {
    lowerBoundCondition = AttributeCondition.create({
      attrName
    });
    let lowerBoundComparator = GeoPointFartherThanComparator.create();
    lowerBoundComparator = GeoPointFartherThanComparator.setValue1(lowerBoundComparator, queryModel.origin);
    lowerBoundComparator = GeoPointFartherThanComparator.setUnits(lowerBoundComparator, queryModel.unit);
    lowerBoundComparator = GeoPointFartherThanComparator.setDistance(lowerBoundComparator, from);
    lowerBoundCondition = AttributeCondition.setComparator(lowerBoundCondition, lowerBoundComparator);
    conditions.push(lowerBoundCondition);
  }
  let rootCondition = ConditionFilterModel.create({
    objectType
  });
  rootCondition = ConditionFilterModel.setRootCondition(rootCondition, LogicCondition.create({
    conditions,
    operator: 'and'
  }));
  const filter = delegate.convertToFilter(rootCondition, context);
  filterSource = FilterSourceModel.setFilter(filterSource, filter);
  filterSource = FilterSourceModel.setMetadata(filterSource, {
    filter: rootCondition
  });
  return filterSource;
}
createGeoDistanceRangeFilter.TYPE = 'aggregation.geoDistance';
export function createRangeFilter(data, {
  queryModel,
  objectType,
  delegate,
  context
}) {
  const {
    attrName
  } = queryModel;
  if (!attrName) {
    return null;
  }
  const {
    from,
    to
  } = data;
  let filterSource = FilterSourceModel.create();
  let attributeCondition = AttributeCondition.create({
    attrName
  });
  let comparator;
  if (from != null && to != null) {
    comparator = NumericBetweenComparator.create();
    comparator = NumericBetweenComparator.setValue1(comparator, from);
    comparator = NumericBetweenComparator.setValue2(comparator, to);
    comparator = NumericBetweenComparator.setIncludesValue1(comparator, true);
    comparator = NumericBetweenComparator.setIncludesValue2(comparator, true);
  } else if (from != null) {
    comparator = NumericGreaterThanComparator.create();
    comparator = NumericGreaterThanComparator.setValue1(comparator, from);
    comparator = NumericGreaterThanComparator.setIncludesValue1(comparator, true);
  } else {
    comparator = NumericLessThanComparator.create();
    comparator = NumericLessThanComparator.setValue1(comparator, to);
    comparator = NumericLessThanComparator.setIncludesValue1(comparator, true);
  }
  attributeCondition = AttributeCondition.setComparator(attributeCondition, comparator);
  let rootCondition = ConditionFilterModel.create({
    objectType
  });
  rootCondition = ConditionFilterModel.setRootCondition(rootCondition, LogicCondition.create({
    conditions: [attributeCondition],
    operator: 'and'
  }));
  const filter = delegate.convertToFilter(rootCondition, context);
  filterSource = FilterSourceModel.setFilter(filterSource, filter);
  filterSource = FilterSourceModel.setMetadata(filterSource, {
    filter: rootCondition
  });
  return filterSource;
}
createRangeFilter.TYPE = 'aggregation.range';
export function createHistogramFilter(data, {
  queryModel,
  objectType,
  delegate,
  context
}) {
  const value = data?.key;
  const {
    attrName,
    interval,
    missing
  } = queryModel;
  if (!attrName) {
    return null;
  }
  const isEmpty = missing === value;
  let filterSource = FilterSourceModel.create();
  let attributeCondition = AttributeCondition.create({
    attrName
  });
  let comparator;
  if (isEmpty) {
    comparator = NotExistsComparator.create();
  } else {
    comparator = NumericBetweenComparator.create();
    comparator = NumericBetweenComparator.setValue1(comparator, value);
    comparator = NumericBetweenComparator.setValue2(comparator, value + interval);
  }
  attributeCondition = AttributeCondition.setComparator(attributeCondition, comparator);
  let rootCondition = ConditionFilterModel.create({
    objectType
  });
  rootCondition = ConditionFilterModel.setRootCondition(rootCondition, LogicCondition.create({
    conditions: [attributeCondition],
    operator: 'and'
  }));
  const filter = delegate.convertToFilter(rootCondition, context);
  filterSource = FilterSourceModel.setFilter(filterSource, filter);
  filterSource = FilterSourceModel.setMetadata(filterSource, {
    filter: rootCondition
  });
  return filterSource;
}
createHistogramFilter.TYPE = 'aggregation.histogram';
export function createFilterFilter(data, {
  queryModel
}) {
  const aggFilter = queryModel?.filter;
  return {
    ...aggFilter,
    metadata: {
      filter: aggFilter.metadata
    }
  };
}
createFilterFilter.TYPE = 'aggregation.filter';
export function createFiltersFilter(data, {
  queryModel
}) {
  const aggFilter = queryModel?.filters?.find(filter => {
    return filter.name === data.key;
  })?.filter;
  return {
    ...aggFilter,
    metadata: {
      filter: aggFilter.metadata
    }
  };
}
createFiltersFilter.TYPE = 'aggregation.filters';
export function cleanFilter(filter, cleanKeys = new Set(['id'])) {
  if (!filter) {
    return filter;
  }
  const nFilter = {};
  if (Array.isArray(filter)) {
    return filter.map(f => cleanFilter(f, cleanKeys));
  }
  Object.entries(filter).forEach(([key, item]) => {
    if (!cleanKeys.has(key)) {
      nFilter[key] = typeof item === 'object' ? cleanFilter(item, cleanKeys) : item;
    }
  });
  return nFilter;
}